<template>
  <div>
    <div v-if="dataLoading" class="row align-items-center ">
      <div class="col-4 text-center pl-1">
        <v-skeleton-loader
            type="card"
        ></v-skeleton-loader>
      </div><div class="col-4 text-center px-1">
      <v-skeleton-loader
          type="card"
      ></v-skeleton-loader>
      </div><div class="col-4 text-center pr-1">
      <v-skeleton-loader
          type="card"
      ></v-skeleton-loader>
      </div>
    </div>
    <div v-else-if="items.length > 0 && items !== undefined" class="row">
      <h1 class="col-8 primary-text">{{ title }}</h1>
      <router-link  :to="{path:'StoreList',query:{isOnline:'false',ShoppingCategoryID:items[0].ShoppingCategoryID,title:title}}" class="col-4 text-left "><span class="primary-text ml-2 pointer">MORE</span>
        <i class="fa-solid fa-arrow-left fa-lg pointer"></i>
      </router-link>
      <div v-for="(item,i) in items.slice(0,8)" :key="i" class="col-4 p-1 col-md-3">
        <div>
          <StoreCard :item="item"/>
        </div>

      </div>


    </div>
  </div>
</template>

<script>
import StoreCard from "@/components/StoreCard";
export default {
  name: "StoresTemplate",
  components: {StoreCard},
  props: ['items', 'title', 'dataLoading'],
  data:()=>({
    sliceItems:[]
  }),
  mounted() {
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
  }
}
</script>
